export default {
  list: {
    title: 'Term',
    subtitle: 'List',
    add: 'New game',
  },
  table: {
    title: 'Active Term games',
    searchPlaceholder: 'Search...',
    letterFilter: 'No. of letters',
    columns: {
      letters: 'No. of letters',
      word: 'Word',
      publishedDate: 'Publish date',
    },
  },
  form: {
    title: {
      create: 'New term',
      edit: 'Edit term',
    },
    name: {
      label: 'Name:',
      invalid: 'Name is required',
    },
    letter: {
      label: 'Letter count:',
    },
    publishedDate: {
      label: 'Published:',
    },
    word: {
      label: 'Word:',
      placeholder: 'Enter the word',
      invalid: 'Word is required',
    },
    attempt: {
      label: 'Attempts:',
      invalid: 'Attempts is required',
    },
  },
  delete: {
    title: 'Confirm game deletion',
    message: 'Are you sure you want to delete this game?',
  },
  alert: {
    deleted: 'Game deleted successfully',
  },
};
